import type { ResponseKind } from '../domain/types'

interface ResponseFieldProps {
  kind: ResponseKind
  label: string
  value: string
  onChange: (value: string) => void
  options?: string[]
  selectedOption?: string
  onOptionChange?: (value: string) => void
  responseOptional?: boolean
  freeTextOptional?: boolean
}

export function ResponseField({
  kind, label, value, onChange, options = [], selectedOption = '', onOptionChange,
  responseOptional = false, freeTextOptional = false,
}: ResponseFieldProps) {
  const hasOptions = options.length > 0 && onOptionChange
  if (kind === 'scale' && !hasOptions) {
    return (
      <label className="response-field response-scale">
        <span>{label}{responseOptional ? ' (optional)' : ''}</span>
        <input
          type="range"
          min="0"
          max="10"
          value={value || '5'}
          onChange={(event) => onChange(event.target.value)}
        />
        <output>{value || '5'} / 10</output>
      </label>
    )
  }

  return (
    <div className="response-field guided-response">
      <span>{label}{responseOptional ? ' (optional)' : ''}</span>
      {hasOptions && (
        <label className="recognition-choice">
          <span>Choose what is closest today</span>
          <select value={selectedOption} onChange={(event) => onOptionChange(event.target.value)}>
            <option value="">Leave open-I do not need to decide</option>
            {options.map((option) => <option key={option} value={option}>{option}</option>)}
          </select>
        </label>
      )}
      <textarea
        aria-label={freeTextOptional ? 'Optional private note' : label}
        rows={kind === 'short_text' ? 3 : 5}
        value={value}
        placeholder={kind === 'plan' ? 'Write the action, time and place…' : 'Capture what is true for you…'}
        onChange={(event) => onChange(event.target.value)}
      />
      {responseOptional && <small>No answer is required. An honest "not sure" is more useful than a polished answer that does not feel true.</small>}
    </div>
  )
}
